import UserPreferences from 'pages/UserPreferences'

export default [
    {
        path: '/user-preferences',
        name: 'userPreferences',
        component: UserPreferences,
    }
]
